import type {CodeList, CodeListMap} from 'services/codelists/types';
import type {Metadata} from '../types';
import {getExpressionManifestationsBasedOnLocalCodelist} from './getExpressionManifestationsBasedOnLocalCodelist';
import {getExpressionManifestationsDigitalVersionLocalCodelist} from './getExpressionManifestationsDigitalVersionLocalCodelist';
import {getExpressionManifestationsLocalCodelist} from './getExpressionManifestationsLocalCodelist';

export const getExpressionLocalCodelistMap = (
  expressionId: string,
  state: {metadataEdit: {metadata?: Pick<Metadata, 'manifestations'>}},
  codelists: {
    productFormOverride: CodeList;
    productForm: CodeList;
    productFormDetails: CodeList;
  },
): CodeListMap => {
  const expressionManifestationCodelist =
    getExpressionManifestationsLocalCodelist(state, expressionId, codelists);
  const expressionManifestationBasedOnCodelist =
    getExpressionManifestationsBasedOnLocalCodelist(
      state,
      expressionId,
      codelists,
    );
  const expressionManifestationDigitalVersionCodelist =
    getExpressionManifestationsDigitalVersionLocalCodelist(
      state,
      expressionId,
      codelists,
    );

  return {
    expression_manifestation: expressionManifestationCodelist,
    expression_manifestation_based_on: expressionManifestationBasedOnCodelist,
    expression_manifestation_digital_version:
      expressionManifestationDigitalVersionCodelist,
  };
};
